import { useEffect } from "react";
import { isStandaloneMode } from "../utils/pwaUtils";
import { useIsMobile } from "./useMediaQuery";

const PWA_CLASS_BY_MODE = {
  client: "client-app-mode",
  admin: "admin-app-mode",
  owner: "owner-app-mode",
  platform: "platform-admin-mode",
};

/**
 * На мобилке и в установленном PWA — класс портала.
 * На десктопе в браузере — desktop-portal.
 */
export function usePortalHtmlClass(mode) {
  const isMobile = useIsMobile(768);
  const pwaClass = PWA_CLASS_BY_MODE[mode] || PWA_CLASS_BY_MODE.admin;

  useEffect(() => {
    const root = document.documentElement;
    const allPwaClasses = Object.values(PWA_CLASS_BY_MODE);

    const applyPortalMode = () => {
      const standalone = isStandaloneMode();
      root.classList.toggle("pwa-standalone", standalone);

      if (isMobile || standalone) {
        for (const cls of allPwaClasses) root.classList.remove(cls);
        root.classList.add(pwaClass);
        root.classList.remove("desktop-portal");
      } else {
        for (const cls of allPwaClasses) root.classList.remove(cls);
        root.classList.add("desktop-portal");
      }
    };

    applyPortalMode();
    const mq = window.matchMedia("(display-mode: standalone)");
    mq.addEventListener("change", applyPortalMode);

    return () => {
      mq.removeEventListener("change", applyPortalMode);
      for (const cls of allPwaClasses) root.classList.remove(cls);
      root.classList.remove("desktop-portal");
      root.classList.remove("pwa-standalone");
    };
  }, [isMobile, pwaClass]);
}
